const options = {
    maximumFractionDigits: 2,
    currency: 'USD',
    style: 'currency',
    currencyDisplay: 'symbol',
};

const getMoneyFormat = (value, isCents) => {
    switch (true) {
        case typeof value !== 'number':
            return '';
        case value < 0:
            return `-${localStringToNumber(isCents ? (-1 * value) / 100 : -1 * value).toLocaleString(
                undefined,
                options,
            )}`;
        case value >= 0:
            return localStringToNumber(isCents ? value / 100 : value).toLocaleString(undefined, options);
        default:
            return '';
    }
};

const localStringToNumber = string => {
    if (typeof string !== 'string' && typeof string !== 'number') {
        throw new Error('Not a string or number has been passed to currencyTool');
    }
    return (string[0] === '(' ? -1 : 1) * Number(String(string).replace(/[^0-9.-]+/g, ''));
};

export const currencyTools = {
    getMoneyFormat,
    localStringToNumber,
};

export const getCurrency = value => {
    return getMoneyFormat(value, false);
};
